"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _TextInput = require("../../TextInput");
var _withMask = _interopRequireDefault(require("../../TextInput/withMask"));
var _createAutoCorrectedDatePipe = _interopRequireDefault(require("./../createAutoCorrectedDatePipe"));
var _ = require("..");
var _StyledDatePicker = require("../StyledDatePicker");
var _ykbStyledComponents = require("../../ykb-styled-components");
var _ykbUtils = require("ykb-utils");
var _excluded = ["onClearClicked", "showTime", "allowClear", "onFocus", "onBlur", "isPickerOpen", "allowInputChange", "picker", "showSuffix", "showSecond"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MaskedInput = (0, _withMask.default)(_TextInput.TextInput);
var DateInput = /*#__PURE__*/function (_Component) {
  function DateInput(p) {
    var _this;
    (0, _classCallCheck2.default)(this, DateInput);
    _this = _callSuper(this, DateInput, [p]);
    (0, _defineProperty2.default)(_this, "getTooltipProps", function (_ref) {
      var theme = _ref.theme,
        triggerOpen = _ref.triggerOpen;
      var target = (0, _ykbUtils.containerChecker)(document);
      return {
        $theme: theme,
        onMouseUp: function onMouseUp(e) {
          e.stopPropagation();
          triggerOpen(true, 0);
        },
        // https://sdlc.yapikredi.com.tr/jira/browse/UXFE-756 numaralı jira kaydının çözümü için, 'onMouseEnter' class ekle/çıkar'ması yapıldı.
        // picker.js - isClickOutside methodu içerisine 'onMouseEnter' kontrolü eklendi.

        // İlk olarak Editable table içerisinde tarih bilgisi yer alan hücrelere tıklandığında aşağıdaki gibi takvim açılmaktadır.
        // Fakat bu hücre içerisindeki takvim imgesine tıklandığında açılan takvim hemen kaybolmaktadır.
        onMouseEnter: function onMouseEnter(e) {
          var _target$querySelector, _target$querySelector2;
          (_target$querySelector = target.querySelector('[class*="-cell"] [class*="-datepicker-input"]')) === null || _target$querySelector === void 0 ? void 0 : (_target$querySelector2 = _target$querySelector.classList) === null || _target$querySelector2 === void 0 ? void 0 : _target$querySelector2.add('on-mouse-enter');
        },
        onMouseLeave: function onMouseLeave(e) {
          var _target$querySelector3, _target$querySelector4;
          (_target$querySelector3 = target.querySelector('[class*="-cell"] [class*="-datepicker-input"]')) === null || _target$querySelector3 === void 0 ? void 0 : (_target$querySelector4 = _target$querySelector3.classList) === null || _target$querySelector4 === void 0 ? void 0 : _target$querySelector4.remove('on-mouse-enter');
        }
      };
    });
    (0, _defineProperty2.default)(_this, "handleChange", function (e, unMaskedValue, maskedValue) {
      if (_this.props.onChange) _this.props.onChange(e, unMaskedValue, maskedValue);
    });
    (0, _defineProperty2.default)(_this, "onBlur", function () {
      var onBlur = _this.props.onBlur;
      _this.setState({
        isFocused: false
      });
      if (onBlur) {
        onBlur.apply(void 0, arguments);
      }
    });
    (0, _defineProperty2.default)(_this, "onFocus", function () {
      var onFocus = _this.props.onFocus;
      _this.setState({
        isFocused: true
      });
      if (onFocus) {
        onFocus.apply(void 0, arguments);
      }
    });
    (0, _defineProperty2.default)(_this, "onKeyDown", function () {
      var onKeyDown = _this.props.onKeyDown;
      if (onKeyDown) {
        onKeyDown.apply(void 0, arguments);
      }
    });
    // Used to replace prefix and suffix symbols
    // When the Swamp Icons prop is set to true, the positions of the prefix and suffix icons change.
    (0, _defineProperty2.default)(_this, "getIcons", function (theme) {
      var _this$props$swapIcons = _this.props.swapIcons,
        swapIcons = _this$props$swapIcons === void 0 ? false : _this$props$swapIcons;
      return {
        prefix: swapIcons ? _this.getSuffix(theme) : _this.getPrefix(theme),
        suffix: swapIcons ? _this.getPrefix(theme) : _this.getSuffix(theme)
      };
    });
    _this.state = {
      isFocused: false
    };
    var timeFormat = p.showSecond ? 'hh mm ss' : 'hh mm';
    var timeMask = p.showSecond ? [/\d/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/] : [/\d/, /\d/, ':', /\d/, /\d/];
    var dateFormat = p.showTime ? _this.checkFormat(p.showTime) : !!p.format ? _this.checkFormat({
      format: p.format
    }) : 'DD MM YYYY';
    var dateMask = p.showTime ? _this.checkMask(p.showTime) : !!p.format ? _this.checkMask({
      format: p.format
    }) : [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    var monthFormat = 'YYYY MM';
    var monthMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    var weekFormat = 'YYYY WW';
    var weekMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    var yearFormat = 'YYYY';
    var yearMask = [/\d/, /\d/, /\d/, /\d/];
    _this.maskFormats = {
      date: {
        pipe: (0, _createAutoCorrectedDatePipe.default)(dateFormat),
        mask: dateMask
      },
      time: {
        pipe: (0, _createAutoCorrectedDatePipe.default)(timeFormat),
        mask: timeMask
      },
      month: {
        pipe: (0, _createAutoCorrectedDatePipe.default)(monthFormat),
        mask: monthMask
      },
      week: {
        pipe: (0, _createAutoCorrectedDatePipe.default)(weekFormat),
        mask: weekMask
      },
      year: {
        pipe: (0, _createAutoCorrectedDatePipe.default)(yearFormat),
        mask: yearMask
      }
    };
    return _this;
  }
  (0, _inherits2.default)(DateInput, _Component);
  return (0, _createClass2.default)(DateInput, [{
    key: "checkFormat",
    value: function checkFormat(showTime) {
      var format = showTime.format;
      if (format && typeof format == 'string') {
        return format;
      } else {
        return 'DD MM YYYY hh mm ss';
      }
    }
  }, {
    key: "checkMask",
    value: function checkMask(showTime) {
      var format = showTime.format;
      if (format && typeof format == 'string') {
        return format.split('').map(function (key) {
          if (key === ' ' || key === '-' || key === ':' || key === '/' || key === '.') {
            return key;
          } else {
            return /\d/;
          }
        });
      } else {
        return [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/];
      }
    }
  }, {
    key: "unMask",
    value: function unMask(value) {
      return value.replace(/\_/g, ''); //.replace(/\//g, '');
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(theme) {
      var _this$props = this.props,
        picker = _this$props.picker,
        triggerOpen = _this$props.triggerOpen,
        icon = _this$props.icon;
      var iconProps = this.getTooltipProps({
        theme: theme,
        triggerOpen: triggerOpen
      });
      if (/*#__PURE__*/(0, _react.isValidElement)(icon)) return /*#__PURE__*/(0, _react.cloneElement)(icon, iconProps);
      if (typeof icon === 'function') return icon(iconProps);
      if (typeof icon === 'string') return /*#__PURE__*/_react.default.createElement(_StyledDatePicker.StyledCustomIcon, (0, _extends2.default)({
        name: icon
      }, iconProps));
      if (picker === 'time') {
        return /*#__PURE__*/_react.default.createElement(_StyledDatePicker.StyledTimeIcon, (0, _extends2.default)({
          name: "clock-alt"
        }, iconProps));
      }
      return /*#__PURE__*/_react.default.createElement(_StyledDatePicker.StyledCalendarIcon, (0, _extends2.default)({
        name: "calendar"
      }, iconProps));
    }
  }, {
    key: "getPrefix",
    value: function getPrefix(theme) {
      var _this$props2 = this.props,
        triggerOpen = _this$props2.triggerOpen,
        extraIcon = _this$props2.extraIcon;
      var iconProps = this.getTooltipProps({
        theme: theme,
        triggerOpen: triggerOpen
      });
      if (/*#__PURE__*/(0, _react.isValidElement)(extraIcon)) return /*#__PURE__*/(0, _react.cloneElement)(extraIcon, iconProps);
      if (typeof extraIcon === 'function') return extraIcon(iconProps);
      if (typeof extraIcon === 'string') return /*#__PURE__*/_react.default.createElement(_StyledDatePicker.StyledCustomIcon, (0, _extends2.default)({
        name: extraIcon
      }, iconProps));
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        onClearClicked = _this$props3.onClearClicked,
        showTime = _this$props3.showTime,
        allowClear = _this$props3.allowClear,
        onFocus = _this$props3.onFocus,
        onBlur = _this$props3.onBlur,
        isPickerOpen = _this$props3.isPickerOpen,
        allowInputChange = _this$props3.allowInputChange,
        picker = _this$props3.picker,
        _this$props3$showSuff = _this$props3.showSuffix,
        showSuffix = _this$props3$showSuff === void 0 ? true : _this$props3$showSuff,
        showSecond = _this$props3.showSecond,
        rest = (0, _objectWithoutProperties2.default)(_this$props3, _excluded);
      var value = this.props.value;
      var isFocused = this.state.isFocused;

      // let controlType = showTime ? this.maskFormats['dateTime'] : this.maskFormats['date'];
      var controlType = this.maskFormats[picker || 'date'];
      if (value) {
        if (picker === 'month') {
          value = value.split('/').reverse().slice(0, 2).join('/');
        } else if (picker === 'week') {
          var momentValue = moment(value, _.formats.dateFormat, true);
          if (momentValue.isValid()) {
            value = "".concat(moment(momentValue).year(), "-").concat(moment(momentValue).week());
          }
        }
      }
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        var preparedIcons = _this2.getIcons(theme);
        return /*#__PURE__*/_react.default.createElement(MaskedInput, (0, _extends2.default)({}, rest, {
          onBlur: _this2.onBlur,
          onFocus: _this2.onFocus,
          onKeyDown: _this2.onKeyDown,
          guide: true,
          unMask: _this2.unMask,
          mask: controlType['mask'],
          keepCharPositions: true,
          pipe: controlType['pipe'],
          showMask: false,
          onChange: _this2.handleChange,
          value: value,
          readOnly: !allowInputChange,
          suffix: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showSuffix && (isPickerOpen && value && allowClear ? /*#__PURE__*/_react.default.createElement(_StyledDatePicker.StyledClearIcon, {
            $theme: theme,
            name: "close-alt",
            onClick: function onClick(e) {
              if (onClearClicked) {
                onClearClicked();
              }
            }
          }) : preparedIcons.suffix)),
          prefix: preparedIcons.prefix
        }));
      });
    }
  }]);
}(_react.Component);
var _default = exports.default = DateInput;